import { render, staticRenderFns } from "./ModalRegraValoresFixosIncluir.vue?vue&type=template&id=6de18072&scoped=true"
import script from "./ModalRegraValoresFixosIncluir.vue?vue&type=script&lang=ts"
export * from "./ModalRegraValoresFixosIncluir.vue?vue&type=script&lang=ts"
import style0 from "./ModalRegraValoresFixosIncluir.vue?vue&type=style&index=0&id=6de18072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de18072",
  null
  
)

export default component.exports